
import Vue from 'vue'
import VueIdb from 'vue-idb'

Vue.use(VueIdb)

export default new VueIdb({
  version: 1,
  database: 'custobov',
  schemas: [
    { simulation: 'code, label, created, changed, active' }
  ]
})